import vr from '@/verify/tip'
const checkParam = {
  inserted: function(el, binding, vNode) {
    let checkInput = $(el).find('input')
    checkInput.addClass('check-input')
    checkInput.blur(e => {
      if (!event.keyCode) {
        checkInput.removeClass('input-error')
        checkInput.next('.error-tips2').remove()
        for (const item of binding.value) {
          // 自定义函数验证
          if (typeof item === 'function') {
            item(checkInput.val(), (msg) => {
              checkInput.addClass('input-error')
              vr(msg, checkInput)
            });
            return
          }
          let itemRule = item.rule
          let itemMsg = item.msg
          // 默认必填验证
          if (itemRule == 'required') {
            if ((!checkInput.val() || checkInput.val() === '')) {
              checkInput.addClass('input-error')
              vr(itemMsg, checkInput)
              return
            }
          } else if (/min/.test(itemRule)) {
            // 最小验证
            let valArr = itemRule.split(':')
            if (+checkInput.val() < +valArr[1]) {
              checkInput.addClass('input-error')
              vr(itemMsg, checkInput)
              return
            }
          } else if (/max/.test(itemRule)) {
            // 最大验证
            let valArr = itemRule.split(':')
            if (+checkInput.val() > +valArr[1]) {
              checkInput.addClass('input-error')
              vr(itemMsg, checkInput)
              return
            }
          } else {
            // 正则验证
            let reg = new RegExp(itemRule).test(checkInput.val())
            if (!reg) {
              checkInput.addClass('input-error')
              vr(itemMsg, checkInput)
              return
            }
          }
        }
      }
    })
  }
}

const checkSubmit = {
  inserted: function(el, binding, vNode) {
    el.addEventListener('click', function(event) {
      let elements = $('[form=' + binding.value + ']')
      var evObj = document.createEvent('Event')
      evObj.initEvent('blur', true, true)
      for (let element of elements) {
        element.dispatchEvent(evObj)
        let errorInputs = document.getElementsByClassName('input-error');
        if (errorInputs.length !== 0) {
          return
        }
      }
      vNode.data.attrs.submit()
    })
  }
}

const checkInput = {
  inserted: function(el, binding, vNode) {
    el.addEventListener('click', function(event) {

      let elements = $('[input=' + binding.value + ']')
      var evObj = document.createEvent('Event')
      evObj.initEvent('blur', true, true)
      for (let element of elements) {
        element.dispatchEvent(evObj)
        let errorInputs = document.getElementsByClassName('input-error');
        if (errorInputs.length !== 0) {
          return
        }
      }
      vNode.data.attrs.confirm()
    })
  }
}


export {
  checkParam,
  checkSubmit,
  checkInput
}


// WEBPACK FOOTER //
// ./src/verify/config.js